<template>
<div>
  <template v-if="consumerName">
    <Details v-if="!isLmrConsumer"/>
    <div v-if="$store.state.consumerGroup == 'ebra'">
      <div class="marker-details">
        <h3 v-if="showVideos" class="highlight">{{ $tc('records.video', 2) }}</h3>
        <h3 v-if="showImages" class="highlight">Images</h3>
      </div>
    </div>
    <div>
      <div class="records-information row">
        <div class="col-md-12">
          <p v-if="records.length && !isLmrConsumer">
            <span class="highlight">
              {{records.length}} {{ $tc('records.video', records.length >= 2 ? 2 : 1) }}
            </span>
            {{ $tc('records.has_been_recorded', records.length >= 2 ? 2 : 1) }}
            <span v-if="diversityTree">
              <br />
              <a href="#" title="show dendrogram" @click.prevent="showTree = !showTree">
                <img
                  style="height: 16px; cursor: pointer; opacity:0.7;"
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAALuSURBVHhe7dw9aFRBFMXx1SiCiAgiCBpBUPGrtBA7G5s0NqlsLG2tg42VlY32NlZ+YGNjY2GjYGkhWAiCEBC/RRBJ1HPhFctyJmPeuzOTvHt+8K/cLOQmuW72Td5ERERERERERERk5ObRA/Qd/R2YPcdDdBTJfziIPiE2zCHZc9pzS8Z9xAbo0T0kGT8QG55H35BksMF5JhlsaJ5JBhuaZ5LBhuaZZLCheSZr2I3Y0DyThNPoDWJD80yIy+gnYgPzTqbsRHcQG1SppHMcvUJsSCUTuIRKvuWwVqHtQLcRG0ytwjqMXiI2lJqFdBF9QWwgtQtlO7qJ/iA2jBaFYZcVnyM2hFQ1fhcI4QL6gNgAUr1G9tuwx3XgVKO/IDOHrqNVxAaQ6i7ahYxdQGeP8cgu9I/WfvQUsU881S90BU07hj4j9vgh2XMeQaN0Hi0j9omneovOIOYAsgvotjLYx66nr8i+86sO3/tcjQ2DHenYgpbQCmIfm+oR2oNGqdS5mo9o+ouwFz1G7LGpfqOryL5wo1XyXI09tzmL3iH2mFTv0Tk0eiXf5LJ1ZN/B9p3M/j3VE7QPhcAG0Cr7v+Ea2orCYINokb0qsldH4bBh1O4ZspeSIbGB1MredLuBtqGw2GBqZC9TF1B4bDile4EOIQE2oJLdQnapUTpsSCWy92kWkcxgwyqRXTyxA1Uygw2rZHawyg5YSYcNqXR2wOoEEmADqpFWUocNp2bhVxIbSu1CryQ2kBaFXUlsGC0Lt5JKn6vp88cUtpJOohBqnKuxA1TrPdsfZiXVOlfT969bQqykmudq+q6kU0iceK8k3S+oB6+VpPsFDdR3JdlPkdH9ghwMWUm6X5CTviupdOH0WUklC6nPSipVWBtlJYXXeiUJtFxJ0mm1kmRG7ZUkRM2VJAm1VpJksKF5JhlsaJ5JBhuaZ5LBhuaZZLCheSYZbGieSUbpc02SofsFNab7BW0Am/5+QSIiIiIiIiIistlMJv8AOUZozSTDIV4AAAAASUVORK5CYII="
                  alt="dendrogram"
                />
              </a>
            </span>
          </p>
        </div>
      <transition name="fade">
        <dendrogram :root="diversityTree" v-if="showTree" class="dendrogram"></dendrogram>
      </transition>
      </div>
      <div class="records">
        <transition name="fade" mode="out-in">
          <div v-if="newVideosCount > 0" class="alert new-record-avaible">
            <span class="badge">{{ newVideosCount }}</span>
            {{ $tc('records.new_available', newVideosCount >= 2 ? 2 : 1) }}
            <a href="#" @click.prevent.stop="swapInNewRecords()">{{ $tc('records.click_here_to_refresh') }}</a>
          </div>
        </transition>
        <div class="row" v-if="$root.$children[0].$data.clientId != 'digiteka'">
          <lmr-city-report-filter
            v-if="!$store.state.editorConsumers[0]"
            class="col-md-6"
            v-model="recordFilters.lmr_cities"
            @change="handleLmrCitySelected"
          />
          <editor-consumer-filter
            v-else
            class="col-md-6"
            v-model="recordFilters.editor_consumers"
            @change="handleEditorConsumerSelected"
          />
          <marker-tags-selector
            ref="tagsFilter"
            class="col-md-6"
            :markerId="markerId"
            @tags-selected="handleTagsSelected"
          />
        </div>
        <div class="row" v-else>
          <lmr-city-report-filter
            class="col-md-12"
            v-model="recordFilters.lmr_cities"
            @change="handleLmrCitySelected"
          />
        </div>
        <div class="row">
          <v-autocomplete
            ref="filterByAuthor"
            class="col-md-6 order_list"
            v-model="recordFilters.user"
            :items="filtersAuthors"
            :rules="[() => !!recordFilters.user || $t('upload_video.field_is_required')]"
            :loading="isLoadingAuthors"
            :search-input.sync="searchFilteredUser"
            hide-no-data
            hide-selected
            item-text="autocomplete_full_name"
            item-value="pk"
            :placeholder="$t('user.filter.filter_by_user')"
            return-object
            outline
            clearable
            single-line
            @input="fetchRecords"
          ></v-autocomplete>
          <v-select
            class="col-md-6 right order_list"
            :placeholder="$t('Ordering')"
            :items="itemsOrdering"
            flat
            outline
            single-line
            v-model="recordOrdering"
            @input="fetchRecords"
          ></v-select>
        </div>
        <div class="row">
          <lmr-category-filter
            class="col-md-6"
            v-if="isLmrConsumer"
            v-model="recordFilters.lmr_category"
            @change="fetchRecords"
          />
          <v-select v-if="consumer_group === 'ebra'"
            class="col-md-6 right order_list"
            :placeholder="$t('departments.filter_by_department')"
            :items="departments"
            flat
            outline
            single-line
            v-model="department"
            @input="fetchRecords"
          ></v-select>
          <sdk-filter
            v-if="consumer_group === 'rossel'"
            v-model="recordFilters.sdk_record"
            @change="fetchRecords"
          />
        </div>


        <!-- <inappropriate-filter
          v-model="recordFilters.inappropriate"
          @change="fetchRecords('VIDEO')"
        /> -->
        <v-tabs v-model="activeTabIndex" fixed-tabs slider-color="#ff2d55">
          <v-tab>
            {{ $t('new') }} <span v-if="newTabRecordsCount" class="badge">{{ newTabRecordsCount }}</span>
          </v-tab>
          <v-tab id="approved_tab">{{ $t('approved') }}</v-tab>
          <v-tab>{{ $t('deleted') }}</v-tab>
        </v-tabs>
        <div v-if="activeTabIndex === recordTabs.new && isLmrConsumer" id="select-mode-btn-wrapper">
          <button
            v-if="records.length"
            id="select-mode-btn"
            class="btn btn-default highlight mr-1"
            :class="{active: approveMode}"department
            @click="toggleApproveMode"
          >{{ $t('approve').toUpperCase() }}</button>
          <button
            v-if="showVideos && records.length > 1"
            id="merge-mode-btn"
            class="btn btn-default highlight"
            :class="{active: mergeMode}"
            @click="toggleMergeMode"
          >{{ $t('merge').toUpperCase() }}</button>

<v-spacer></v-spacer>
<template>
<!--  <button-->
<!--    v-if="records.length"-->
<!--    id="download-mode-btn"-->
<!--    class="btn btn-default mr-1 highlight"-->
<!--    :class="{active: downloadMode}"-->
<!--    @click.stop="toggleDownloadMode"-->
<!--  >-->
<!--    {{ $t('upload_video.download_video_title').toUpperCase() }}-->
<!--  </button>-->
  <button
    id="add-video-mode-btn"
    class="btn btn-default highlight right"
    @click.stop="dialog = true"
    v-if="!videoFileUploading && !showImages"
  >
    {{ $t('upload_video.upload_video_title').toUpperCase() }}
  </button>
  <v-dialog
    v-model="dialog"
    persistent max-width="600px"
  >
    <v-card style="padding: 20px">
      <v-card-title>
        <span class="headline">{{ $t('upload_video.upload_video_title') }}</span>
      </v-card-title>
      <v-card-text v-if="videoFileUploading">
        <v-container  style="padding: 0">
          <div
            class="subtitle-1 text-center"
            cols="12"
          >
            {{ $t('upload_video.upload_progress') }} ({{ bufferVideoUploading }}%)
          </div>
            <v-progress-linear
              v-model="bufferVideoUploading"
              :buffer-value="100"
              color="#ff2d55"
              bufferVideoUploading
              height="6"
            ></v-progress-linear>
        </v-container>
      </v-card-text>
      <v-card-text v-else>
        <div v-if="!uploadingVideoFile">
          <div
            :class="['dropZone', dragging ? 'dropZone-over' : '']"
            @dragenter="dragging = true"
            @dragleave="dragging = false"
          >
            <div class="dropZone-info" @drag="onChange">
              <span class="fa fa-cloud-upload dropZone-title"></span>
              <span class="dropZone-title">{{ $t('upload_video.drop_file_or_click')}}</span>
              <div class="dropZone-upload-limit-info">
                <div>{{ $t('upload_video.support_file') }}</div>
                <div>{{ $t('upload_video.max_file_size')}}: 500 MB</div>
                <div v-if="uploadVideoFormHasErrors">{{ $t('upload_video.you_must_add_video_file') }}</div>
              </div>
            </div>
            <input type="file" @change="onChange">
          </div>
        </div>
        <div v-else class="dropZone-uploaded">
          <div class="dropZone-uploaded-info">
            <span class="dropZone-title">{{ $t('upload_video.checked') }}</span>
             <div class="uploadedFile-info">
              <div>{{ $t('upload_video.file_name') }}: {{ uploadingVideoFile.name }}</div>
              <div>{{ $t('upload_video.file_size') }}: {{ (uploadingVideoFile.size / 1000000).toFixed(2) }} MB</div>
              <div>{{ $t('upload_video.extension') }}: {{ extension }}</div>
            </div>
            <button type="button" class="btn btn-primary removeFile" @click="removeFile">{{ $t('upload_video.remove_file') }}</button>
          </div>
        </div>
        <div>
          <v-radio-group
            v-model="typeVideoUpload"
            row
            ref="typeVideoUpload"
            :rules="[() => !!typeVideoUpload || $t('upload_video.field_is_required')]"
          >
            <v-radio
              color="rgb(255, 45, 85)"
              v-for="item in videoUploadTypes"
              :key="item.id"
              :label="item.name"
              :value="item.value"
            ></v-radio>
          </v-radio-group>
          <v-autocomplete
            ref="uploadVideoAuthor"
            v-model="uploadVideoAuthor"
            :items="entriesAuthors"
            :rules="[() => !!uploadVideoAuthor || $t('upload_video.field_is_required')]"
            :loading="isLoadingAuthors"
            :search-input.sync="search"
            color="#ff2d55"
            hide-no-data
            hide-selected
            item-text="autocomplete_full_name"
            item-value="pk"
            :placeholder="$t('upload_video.start_typing')"
            return-object
          ></v-autocomplete>
          <v-text-field
            ref="titleVideoUpload"
            :rules="[() => !!titleVideoUpload || $t('upload_video.field_is_required')]"
            color="#ff2d55"
            v-model="titleVideoUpload"
            :counter="100"
            :label="$t('upload_video.title')"
            required
          ></v-text-field>
          <v-textarea
            v-if="consumerHasDescriptionField"
            ref="descriptionVideoUpload"
            :rules="[() => !!descriptionVideoUpload || $t('upload_video.field_is_required')]"
            color="#ff2d55"
            v-model="descriptionVideoUpload"
            name="input-7-1"
            :label="$t('upload_video.description')"
            value=""
            hint="Hint text"
          ></v-textarea>
        </div>
      </v-card-text>
      <v-card-actions style="padding: 16px">
        <v-spacer></v-spacer>
        <v-btn color="#ff2d55" outline @click="dialog = false">{{ $t('upload_video.close') }}</v-btn>
        <v-btn v-if="!videoFileUploading" color="#ff2d55" outline @click="uploadData">
          {{ $t('upload_video.upload') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

        </div>

        <div v-show="loading && !records.length" class="loading-indicator center-block"></div>
        <p v-if="!records.length && !loading" class="empty">
          {{ $t("records.none_available") }}
        </p>
        <records-list
          :records="records"
          :marker-id="markerId"
          :selectedRecords="selectedRecords"
          :showSelectIndex="mergeMode"
          @delete-record="handleRecordDelete"
          @restore-record="handleRecordRestore"
          @mark-record-relevance="markRecordRelevance"
          @clicked-record="recordClicked"
          :isChoosingMode="approveMode || mergeMode || downloadMode"
        />
        <div v-show="amountOfPages > 1">
          <v-pagination
            v-model="currentPage"
            @input="records = []; fetchRecords()"
            :length="amountOfPages"
            :total-visible="10"
          ></v-pagination>
        </div>
        <div v-if="mergeMode || approveMode || downloadMode" style="margin-bottom: 100px"></div>
      </div>

      <div v-if="approveMode" class="select-mode-bar">
        <div class="container">
          <button
            v-if="!showImages"
            class="btn btn-info left"
            @click="downloadRecords"
            :disabled="!selectedRecords.length"
          >{{ $t('download').toUpperCase() }} ({{ selectedRecords.length }})</button>
          <button
            v-if="showImages"
            class="btn btn-info left"
            @click="downloadRecordsZip"
            :disabled="!selectedRecords.length"
          >{{ $t('download').toUpperCase() }} ({{ selectedRecords.length }})</button>
          <button
            class="btn btn-danger left"
            @click="toggleApproveMode"
            :disabled="false"
          >{{ $t('cancel').toUpperCase() }}</button>
          <button
            class="btn btn-danger"
            @click="rejectRecords"
            :disabled="!selectedRecords.length"
          >{{ $t('reject').toUpperCase() }} ({{ selectedRecords.length }})</button>
          <button
            v-if="!showImages"
            class="btn btn-success"
            @click="approveRecords"
            :disabled="!selectedRecords.length"
          >{{ $t('records.approve').toUpperCase() }} ({{ selectedRecords.length }})</button>

        </div>
      </div>

      <div v-if="mergeMode" class="select-mode-bar">
        <div class="container">
          <button
            class="btn btn-danger left"
            @click="toggleMergeMode"
          >{{ $t('cancel').toUpperCase() }}</button>
          <button
            class="btn btn-success"
            @click="setMergeRecordTitle(false)"
            :disabled="!(selectedRecords.length > 1)"
          >{{ $t('merge').toUpperCase() }} ({{ selectedRecords.length }})</button>
          <button
            class="btn btn-success"
            @click="setMergeRecordTitle(true)"
            :disabled="!(selectedRecords.length > 1)"
          >{{ $t('merge_abd_approve').toUpperCase() }} ({{ selectedRecords.length }})</button>
        </div>
      </div>

<!--      <div v-if="downloadMode" class="select-mode-bar">-->
<!--        <div class="container">-->
<!--          <button-->
<!--            class="btn btn-danger"-->
<!--            @click="toggleDownloadMode"-->
<!--          >{{ $t('cancel').toUpperCase() }}</button>-->
<!--          <button-->
<!--            class="btn btn-success"-->
<!--            @click="downloadRecords"-->
<!--            :disabled="!selectedRecords.length"-->
<!--          >{{ $t('download').toUpperCase() }} ({{ selectedRecords.length }})</button>-->
<!--        </div>-->
<!--      </div>-->

      <record-details
        :record="selectedRecord"
        v-if="selectedRecord"
        @clicked-similar-record="showRecordDetails"
        @close="selectedRecord = null"
        @cut-started="setCutIcon"
      >
      </record-details>

      <template v-if="relatedRecords.length > 0">
        <div class="records-information related-records row">
          <div class="col-md-12">
            <h3>{{ $tc('records.related_streams_title') }}</h3>
            <p class="help-block">
              <em>
                {{ $tc('records.related_streams_help') }}
              </em>
            </p>
          </div>
        </div>
        <div class="records related-records row">
          <!-- Marker related VODs list: -->
          <records-list :records="relatedRecords" :read-only="true"></records-list>
        </div>
      </template>

      <modal
        v-if="showPremergeModal"
        :show="showPremergeModal"
        @ok="mergeRecords"
        @hide="toggleMergeMode"
        :okBtnText="$t('records.start_merge')"
      >
        <template slot="body">
          <div class="edit-record-notes form-group">
            <div v-if="consumerHasDescriptionField" class="form-row">
              <input name="record-title" rows="8" cols="80" class="form-control"
               v-model="mergeData.title"
              />
              <textarea name="record-description" rows="8" cols="80" class="form-control"
               v-model="mergeData.description"
              ></textarea>
            </div>
            <div v-else>
              <textarea name="record-comment" rows="8" cols="80" class="form-control"
               v-model="mergeData.title"
              ></textarea>
            </div>
          </div>
        </template>
      </modal>
    </div>
  </template>
</div>
</template>

<script>

import Details from './Details.vue'
import Dendrogram from '../marker/MarkerDendrogram.vue'
import events from '../../services/events'
import MarkerTagsSelector from '../marker/record/MarkerTagsSelector'
import InappropriateFilter from '../marker/record/InappropriateFilter'
import RecordDetails from '../marker/record/RecordDetails.vue'
import RecordRepository from '../../repositories/RecordRepository.js'
import RecordsList from '../marker/record/RecordsList.vue'
import LmrCategoryFilter from '../marker/record/LmrCategoryFilter'
import LmrCityReportFilter from '../marker/record/LmrCityReportFilter'
import SdkFilter from '../marker/record/SdkFilter'
import Modal from '@/components/generic/Modal.vue'
import { mapGetters, mapActions, mapState } from 'vuex'
import auth from '../../services/auth'
import http from '../../services/http'
import UserRepository from '../../repositories/UserRepository'
import EditorConsumerFilter from '../marker/record/EditorConsumerFilter'

export default {
  components: {
    Details,
    RecordsList,
    Dendrogram,
    MarkerTagsSelector,
    InappropriateFilter,
    RecordDetails,
    LmrCategoryFilter,
    LmrCityReportFilter,
    SdkFilter,
    Modal,
    EditorConsumerFilter,
  },
  props: [
    'markerId',
    'recordType',
  ],
  data: function () {
    return {
      records: [],
      newVideosCount: 0,
      relatedRecords: [], // deprecated
      diversityTree: null, // deprecated
      showTree: false, // deprecated
      timer: '',
      processStatusInterval: null,
      mergeRecordTimeout: null,
      loading: true,
      recordFilters: {
        tags: [],
        // inappropriate: 'hide',
        // special filters for LMR consumer
        lmr_category: '',
        sdk_record: '',
        lmr_cities: [],
        user: null,
        editor_consumers: []
      },
      recordOrdering: '',
      itemsOrdering: [],
      recordTabs: {
        new: 0,
        approved: 1,
        deleted: 2,
      },
      activeTabIndex: null,
      newTabRecordsCount: 0,
      pageSize: 20,
      currentPage: 1,
      selectedRecord: null,
      approveMode: false,
      mergeMode: false,
      downloadMode: false,
      selectedRecords: [], // used for select/merge mode
      pageLoadDate: null, // used for checking that new records have appreared
      showPremergeModal: false,
      mergeData: {
        approve: false,
        title: '',
        description: '',
      },
      dialog: false,
      uploadingVideoFile: '',
      dragging: false,
      titleVideoUpload: '',
      authorVideoUpload: '',
      descriptionVideoUpload: '',
      typeVideoUpload: 'sport',
      uploadVideoFormHasErrors: false,
      videoFileUploading: false,
      videoUploadTypes: [
        { value: 'sport', name: 'Sports' },
        { value: 'general', name: 'Infos locales' }
      ],
      isLoadingAuthors: false,
      uploadVideoAuthor: null,
      search: null,
      searchFilteredUser: null,
      filtersAuthors: [],
      entriesAuthors: [],
      bufferVideoUploading: 0,
      user_groups: [],
      consumer_group: '',
      departments: [],
      department: ''
    }
  },
  beforeMount () {
    const tabEntries = Object.entries(this.recordTabs)
    const tab = tabEntries.find(
      ([name, index]) => name === this.$route.params.tab
    ) || tabEntries[0]
    this.activeTabIndex = tab[1]
  },
  mounted () {
    this.fetchRecords()
    this.setPageLoadDate()
    this.setupInterval()
    this.processStatusInterval = setInterval(
      this.updateRecordProcessStatus, 10000
    )
    // this.fetchRelatedRecords()
    // this.fetchRecordsDiversity()
    UserRepository.fetchMyUserDetails().then(data => {
      this.user_groups = data.user_group_list
      this.consumer_group = data.consumer_group
      if (data.consumer_group === 'ebra') {
        this.videoUploadTypes.push({value: 'magazine', name: 'Magazine'})
      }
      if (this.$store.state.consumerName === 'lng') {
        this.videoUploadTypes.push({value: 'faits_divers', name: 'Faits Divers'})
      }
      if (data.consumer_group === 'ebra') {
        this.departments = data.departments.map((department) => ({text: department.name, value: department.slug}))
        var d = [
          {text: this.$t('departments.all'), value: '0'},
        //  {text: 'Without Department', value: 'None'}
        ]
        this.departments = d.concat(this.departments)
      }
    })
  },

  computed: {
    ...mapGetters(['isLmrConsumer']),
    ...mapState(['consumerName', 'consumerHasDescriptionField']),
    showVideos () {
      return this.recordType === 'VIDEO'
    },
    showImages () {
      return this.recordType === 'IMAGE'
    },
    amountOfPages () {
      return Math.ceil(this.records.count / this.pageSize) || 1
    },
    activeTabName () {
      return Object.entries(this.recordTabs)
        .find((name, index) => index === this.activeTabIndex)[0]
    },
    extension () {
      return (this.uploadingVideoFile) ? this.uploadingVideoFile.name.split('.').pop() : ''
    },
    uploadVideoForm () {
      return {
        titleVideoUpload: this.titleVideoUpload,
        uploadVideoAuthor: this.uploadVideoAuthor,
        // descriptionVideoUpload: this.descriptionVideoUpload,
        typeVideoUpload: this.typeVideoUpload
      }
    }
  },

  methods: {
    ...mapActions(['syncFtp', 'syncImagesFtp']),
    setupInterval () {
      clearInterval(this.timer)
      this.timer = setInterval(this.updateRecords.bind(this), 30000)
    },
    handleRecordDelete (record, recordType) {
      // handle record delete confirmation, submit to backend and reload records list
      RecordRepository.deleteRecord(this.markerId, record).then(() => {
        this.fetchRecords(recordType)
      }, (error) => {
        events.emit('error', error, '', {modal: false})
      })
    },
    handleRecordRestore (record, recordType) {
      RecordRepository.restoreRecord(this.markerId, record).then(() => {
        this.fetchRecords()
      }, (error) => {
        events.emit('error', error, '', {modal: false})
      })
    },
    handleTagsSelected (tags) {
      this.recordFilters.tags = tags
      this.fetchRecords()
    },
    handleLmrCitySelected (cities) {
      this.recordFilters.lmr_cities = cities
      this.fetchRecords()
    },
    handleEditorConsumerSelected (consumers) {
      this.recordFilters.editor_consumers = consumers
      this.fetchRecords()
    },
    fetchRecordsFromRepository (recordType, page, tabName) {
      return RecordRepository.fetchMarkerRecords(
        this.markerId,
        page || this.currentPage,
        this.pageSize,
        this.recordOrdering,
        this.department,
        this.recordFilters,
        recordType || this.recordType,
        tabName || this.activeTabName,
      )
    },
    updateRecords () {
      const route = this.$route.path
      const page = this.showVideos ? this.currentPage : 1
      const tabName = this.showVideos ? this.activeTabName : 'new'
      // this.itemsOfOrdering()
      this.fetchRecordsFromRepository('VIDEO', page, tabName).then((records) => {
        if (
          this.$route.path !== route ||
          page !== (this.showVideos ? this.currentPage : 1)
        ) return // skip stale results

        var newVideosCount = records.filter(record => {
          if (record.transcoding_complete_date) {
            var timestamp = new Date(record.transcoding_complete_date).getTime()
            return timestamp > this.pageLoadDate
          }
        }).length

        if (this.showImages) {
          if (newVideosCount) this.newVideosCount = newVideosCount
          return
        }

        // further code goes for showVideos == true
        if (this.records.length === 0) {
          // if we had no videos previously, just load up the new one(s)
          this.records = records
          if (this.activeTabIndex === this.recordTabs.new) {
            this.newTabRecordsCount = records.count
            this.setPageLoadDate()
          }
          this.$refs.tagsFilter.fetchTags()
          return
        }

        if (newVideosCount > 0) {
          // store the new videos count to show notification about new vids
          this.newVideosCount = newVideosCount
          // update records state but don't update records list
          this.records.forEach((record, index) => {
            const freshRecord = records.find(rec => rec.id === record.id)
            if (!freshRecord.digiteka_id) freshRecord.digiteka_id = this.records[index].digiteka_id
            if (freshRecord) this.records[index] = freshRecord
            this.records = this.records.slice() // activate reactivity system
            // this.records = records
          })
        } else {
          // update records state
          // this.records = records
          this.records.forEach((record, index) => {
            const freshRecord = records.find(rec => rec.id === record.id)
            if (!freshRecord.digiteka_id) freshRecord.digiteka_id = record.digiteka_id
            if (freshRecord) this.records[index] = freshRecord
            // this.records = this.records.slice() // activate reactivity system
          })
          if (this.activeTabIndex === this.recordTabs.new) {
            this.newTabRecordsCount = records.count
          }
        }
      })
    },
    swapInNewRecords () {
      if (this.showImages) {
        this.$router.push('/videos/new')
      } else if (this.activeTabIndex !== this.recordTabs.new) {
        this.activeTabIndex = 0
      } else {
        this.fetchRecords()
      }
      this.newVideosCount = 0
    },
    fetchRecords () {
      this.loading = true
      const route = this.$route.path
      const page = this.currentPage

      this.fetchRecordsFromRepository().then((records) => {
        if (this.$route.path !== route || this.currentPage !== page) return // skip stale results
        this.records = records
        if (this.activeTabIndex === this.recordTabs.new) {
          this.newTabRecordsCount = records.count
          if (this.showVideos && this.currentPage === 1) {
            // update pageLoadDate every time we update videos on first page
            this.setPageLoadDate()
          }
        }
        this.loading = false
      }, (error) => {
        this.loading = false
        events.emit('error', error)
      })
      if (this.activeTabIndex === this.recordTabs.approved) {
        this.itemsOrdering = [
          {text: this.$t('ordering.by_shooting_date_new_old'), value: '-shooting_date'},
          {text: this.$t('ordering.by_shooting_date_old_new'), value: 'shooting_date'},
          {text: this.$t('ordering.by_approve_date_new_old'), value: '-approved_date'},
          {text: this.$t('ordering.by_approve_date_old_new'), value: 'approved_date'},
        ]
      } else {
        this.itemsOrdering = [
          {text: this.$t('ordering.by_shooting_date_new_old'), value: '-shooting_date'},
          {text: this.$t('ordering.by_shooting_date_old_new'), value: 'shooting_date'},
        ]
      }
    },
    // fetchRelatedRecords () {
    //   if (!this.markerId) return
    //   RecordRepository.fetchMarkerRelatedRecords(this.markerId, this.activeTabName)
    //     .then((records) => { this.relatedRecords = records })
    // },
    // fetchRecordsDiversity () {
    //   if (!this.markerId) return
    //   RecordRepository.fetchMarkerRecordsDiversityTree(this.markerId)
    //     .then((response) => { this.diversityTree = response.tree })
    // },
    markRecordRelevance (record, relevance, recordType) {
      const r = this.getRecords(recordType).find((r) => { return r.id === record.id })
      if (r && r.mldata) {
        r.mldata.marked_as_relevant = relevance
      }
      RecordRepository.patchRecordRelevance(this.markerId, record, relevance)
      .catch((error) => {
        events.emit('error', error, '', {modal: false})
      })
    },
    getRecords (recordType) {
      const typeMapping = {
        'VIDEO': this.records,
        'IMAGE': this.imageRecords
      }
      return typeMapping[recordType]
    },
    showRecordDetails (record) {
      this.selectedRecord = record
    },
    recordClicked (record) {
      if (this.approveMode || this.mergeMode || this.downloadMode) {
        // add or remove record from selected
        if (!this.selectedRecords.some(rec => rec.id === record.id)) {
          this.selectedRecords.push(record)
        } else {
          this.selectedRecords = this.selectedRecords.filter(rec => rec.id !== record.id)
        }
      } else {
        this.showRecordDetails(record)
      }
    },
    isChoosingMode () {
      return this.approveMode || this.mergeMode || this.downloadMode
    },
    toggleApproveMode () {
      this.selectedRecords = []
      this.approveMode = !this.approveMode
      this.mergeMode = false
      this.downloadMode = false
      if (!this.approveMode) document.activeElement.blur()
    },
    toggleMergeMode () {
      this.selectedRecords = []
      this.mergeMode = !this.mergeMode
      this.approveMode = false
      this.downloadMode = false
      this.showPremergeModal = false
      this.mergeData.approve = false
      this.mergeData.title = ''
      this.mergeData.description = ''
      if (!this.mergeMode) document.activeElement.blur()
    },
    // toggleDownloadMode () {
    //   this.selectedRecords = []
    //   this.approveMode = false
    //   this.mergeMode = false
    //   this.downloadMode = !this.downloadMode
    //   if (!this.downloadMode) document.activeElement.blur()
    // },
    rejectRecords () {
      const ids = this.selectedRecords.map(rec => rec.id)
      RecordRepository.rejectRecords(ids).then(() => {
        this.toggleApproveMode()
        this.fetchRecords()
      }, (error) => {
        events.emit('error', error, '', {modal: false})
      })
    },
    approveRecords () {
      const ids = this.selectedRecords.map(rec => rec.id)
      RecordRepository.approveRecords(ids).then(() => {
        this.toggleApproveMode()
        if (this.$root.$children[0].$data.clientId === 'digiteka') {
          this.$store.commit('snackbar/show', {
            message: this.$t('approve_msg'),
            color: '#0fd3bd',
            href: 'https://www.ultimedia.com/central/video/list/',
            timeout: 30000,
          })
        }
        this.fetchRecords()
      }, (error) => {
        events.emit('error', error, '', {modal: false})
      })
    },
    async downloadRecord (record) {
      const FileSaver = require('file-saver')
      const res = await fetch(record.play_link)
      const blob = await res.blob()
      FileSaver.saveAs(blob, record.verbose_filename)
    },
    downloadRecords () {
      this.selectedRecords.forEach((value, index) => this.downloadRecord(value))
      this.toggleApproveMode()
    },
    async downloadRecordsZip () {
      const ids = this.selectedRecords.map(rec => rec.id)
      if (ids.length === 1) {
        this.downloadRecords()
      } else {
        RecordRepository.downloadRecordsZip(ids).then(data => {
          this.toggleApproveMode()
          if (data.download_url) {
            const FileSaver = require('file-saver')
            FileSaver.saveAs(data.download_url, 'images.zip')
          } else {
            alert('Error in downloading zip')
          }
        })
      }
    },
    setMergeRecordTitle (approve) {
      if (this.consumerHasDescriptionField) {
        this.mergeData.title = this.concatenateSelectedRecordsField('title')
        this.mergeData.description = this.concatenateSelectedRecordsField('description')
      } else {
        this.mergeData.title = this.concatenateSelectedRecordsField('title')
      }
      this.mergeData.approve = approve
      this.showPremergeModal = true
    },
    mergeRecords (approve) {
      const data = Object.assign({}, this.mergeData)
      const ids = this.selectedRecords.map(rec => rec.id)
      RecordRepository.mergeRecords(ids, this.mergeData).then(() => {
        this.toggleMergeMode()
        if (data.approve) {
          if (this.$root.$children[0].$data.clientId !== 'digiteka') {
            this.$store.commit('snackbar/show', {
              message: this.$t('merge_and_approve_msg_pm'),
              color: 'green',
              timeout: 30000,
            })
          } else {
            this.$store.commit('snackbar/show', {
              message: this.$t('merge_and_approve_msg_iframe_digiteka'),
              color: '#0fd3bd',
              href: 'https://www.ultimedia.com/central/video/list/',
              timeout: 30000,
            })
          }
        } else {
          if (this.$root.$children[0].$data.clientId !== 'digiteka') {
            this.$store.commit('snackbar/show', {
              message: this.$t('merge_msg'),
              color: 'green',
              timeout: 30000,
            })
          } else {
            this.$store.commit('snackbar/show', {
              message: this.$t('merge_msg'),
              color: '#0fd3bd',
              timeout: 30000,
            })
          }
        }
        this.mergeRecordTimeout = setTimeout(() => this.fetchRecords('VIDEO'), 2000)
      }, error => {
        events.emit('error', error, '', {modal: false})
        this.$store.commit('snackbar/show', {
          message: error.message,
          color: 'error',
          timeout: 4,
        })
      })
    },
    restoreRecords () {
      const ids = this.selectedRecords.map(rec => rec.id)
      RecordRepository.restoreRecords(ids).then(() => {
        this.toggleApproveMode()
        this.fetchRecords()
      }, (error) => {
        events.emit('error', error, '', {modal: false})
      })
    },
    setCutIcon (record) {
      const rec = this.records.find(r => r.id === record.id)
      if (rec) {
        rec.process_statuses.push({
          process: 'cut', status: 'running'
        })
      }
    },
    updateRecordProcessStatus () {
      RecordRepository.getRecordsStatuses(this.records.map(record => record.id))
        .then(resp => {
          for (let record of this.records) {
            record.process_statuses = resp.filter(
              item => item.record === record.id
            )
          }
        })
    },
    setRecordTabRoute () {
      if (this.$route.params.tab !== this.activeTabName) {
        this.$router.replace({
          name: this.$route.name,
          params: {tab: this.activeTabName}
        })
      }
    },
    setPageLoadDate () {
      this.pageLoadDate = new Date().getTime()
    },
    concatenateSelectedRecordsField (fieldName) {
      return this.selectedRecords.reduce((text, record, index) => {
        if (index === 1) {
          if (text[fieldName] && record[fieldName]) {
            return text[fieldName] + '; ' + record[fieldName]
          } else {
            return text[fieldName] || record[fieldName]
          }
        } else if (text && record[fieldName]) {
          return text + '; ' + record[fieldName]
        } else {
          return record[fieldName]
        }
      })
    },
    onChange (e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        this.dragging = false
        return
      }
      this.createFile(files[0])
    },
    createFile (file) {
      if (!file.type.match('video.*')) {
        alert(this.$t('upload_video.please_select_video_file'))
        this.dragging = false
        return
      }
      if (file.size > 500000000) {
        alert(this.$t('upload_video.please_check_file'))
        this.dragging = false
        return
      }
      this.uploadingVideoFile = file
      this.dragging = false
    },
    removeFile () {
      this.uploadingVideoFile = ''
    },
    async uploadData () {
      this.uploadVideoFormHasErrors = false
      if (!this.uploadingVideoFile) {
        this.uploadVideoFormHasErrors = true
      }
      Object.keys(this.uploadVideoForm).forEach(f => {
        if (!this.uploadVideoForm[f]) this.uploadVideoFormHasErrors = true
        this.$refs[f].validate(true)
      })

      if (!this.uploadVideoFormHasErrors) {
        let headers = auth.getAuthHeader()
        let uploadUrlData = await http.post(
          '/record/raw/upload/',
          headers,
          {
            comment: this.descriptionVideoUpload,
            record_type: 'VIDEO',
            address: '',
            user_id: this.uploadVideoAuthor.pk
          }
        )
        const uploadDone = rawRecordId => {
          let url = '/record/raw/upload/' + rawRecordId + '/done/'
          headers['Content-Type'] = 'application/json'
          return http.post(url, headers,
            {
              'title': this.titleVideoUpload,
              'description': this.descriptionVideoUpload,
              'lmr_category': this.typeVideoUpload,
              'user_id': this.uploadVideoAuthor.pk,
              'autoapprove': false
            }
          )
        }
        var xhr = new XMLHttpRequest()
        xhr.upload.onprogress = event => {
          this.bufferVideoUploading = parseInt((event.loaded / event.total) * 100)
        }
        var ref = this
        xhr.onload = xhr.onerror = function () {
          if (this.status === 200) {
            uploadDone(uploadUrlData.id)
            ref.mergeRecordTimeout = setTimeout(() => ref.fetchRecords('VIDEO'), 2000)
            ref.videoFileUploading = false
            ref.dialog = false
            ref.uploadingVideoFile = ''
            ref.dragging = false
            ref.titleVideoUpload = ''
            ref.authorVideoUpload = ''
            ref.descriptionVideoUpload = ''
            ref.typeVideoUpload = 'sport'
            ref.uploadVideoFormHasErrors = false
            ref.videoFileUploading = false
            ref.bufferVideoUploading = 0
          } else {
            console.log('error ' + this.status)
          }
        }

        xhr.open('PUT', uploadUrlData.upload_link, true)
        xhr.setRequestHeader('Accept', '*/*')
        xhr.setRequestHeader('Content-Type', 'video/mp4')
        xhr.send(this.uploadingVideoFile)
        this.videoFileUploading = true
      }
    }
  }, // methods

  beforeDestroy: function () {
    clearInterval(this.timer)
    clearInterval(this.processStatusInterval)
    clearTimeout(this.mergeRecordTimeout)
  },

  watch: {
    $route (to, from) {
      if (to.name !== from.name) {
        // update on route change from videos to images and vice versa
        this.activeTabIndex = 0
        this.newTabRecordsCount = 0
      }
      this.records = []
      this.currentPage = 1
      this.mergeMode = false
      this.approveMode = false
      this.downloadMode = false
      this.selectedRecords = []
      this.fetchRecords()
      // this.fetchRelatedRecords()
    },
    activeTabIndex (newVal, oldVal) {
      this.recordOrdering = ''
      clearTimeout(this.mergeRecordTimeout)
      this.setRecordTabRoute()
    },
    searchFilteredUser (val) {
      if (this.recordFilters.user && val === this.recordFilters.user.autocomplete_full_name) {
        this.filtersAuthors = [this.recordFilters.user]
        return
      }
      this.recordFilters.user = null
      // Items have already been loaded
      // this.uploadVideoAuthor = null
      if (!val) {
        this.filtersAuthors = []
        this.recordFilters.user = null
        return
      }
      if (this.isLoadingAuthors) return
      this.isLoadingAuthors = true
      let headers = auth.getAuthHeader()
      http.get('/media_platform/autocomplete/user/?search=' + val, headers, undefined, true)
        .then(res => {
          this.filtersAuthors = res
        })
        .catch(err => {
          console.log(err)
          console.log('----', err)
        })
        .finally(() => (this.isLoadingAuthors = false))
    },
    search (val) {
      if (this.uploadVideoAuthor && val === this.uploadVideoAuthor.autocomplete_full_name) {
        this.entriesAuthors = [this.uploadVideoAuthor]
        return
      }
      this.uploadVideoAuthor = null
      // Items have already been loaded
      // this.uploadVideoAuthor = null
      if (!val) {
        this.entriesAuthors = []
        this.uploadVideoAuthor = null
        return
      }

      // Items have already been requested
      if (this.isLoadingAuthors) return
      this.isLoadingAuthors = true
      let headers = auth.getAuthHeader()
      // Lazily load input items
      http.get('/media_platform/autocomplete/user/?search=' + val, headers, undefined, true)
        .then(res => {
          this.entriesAuthors = res
        })
        .catch(err => {
          console.log(err)
          console.log('----', err)
        })
        .finally(() => (this.isLoadingAuthors = false))
    }
  }, // watch
}
</script>

<style lang="sass">
.v-tabs__item
  .badge
    margin-left: 5px
.records
  .loading-indicator
    margin-top: 20px
.order_list
  .v-input__control
    display: flex
    flex-direction: column
    height: auto
    flex-grow: 1
    flex-wrap: wrap
    width: 100%
    margin: 0 15px
.order_list.v-text-field--outline > .v-input__control > .v-input__slot
  border: 1px solid #e8e8e8
.order_list.v-text-field--outline:not(.v-input--is-focused):not(.v-input--has-state) > .v-input__control > .v-input__slot:hover
  border: 1px solid #e8e8e8
.order_list.v-text-field.v-text-field--enclosed > .v-input__control > .v-input__slot
  min-height: 42px
  padding-right: 8px
.order_list.v-text-field.v-text-field--enclosed .v-input__append-inner
  margin-top: 8px
#download-mode-btn
  opacity: 0.5
</style>

<style lang="css">
.dropZone {
  width: 100%;
  height: 200px;
  position: relative;
  border: 2px dashed #eee;
}

.dropZone:hover {
  border: 2px solid #ff2d55;
}

.dropZone:hover .dropZone-title {
  color: #ff2d55;
  font-weight: bold;
}

.dropZone-info {
  /*color: #A8A8A8;*/
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
  text-align: center;
}

.dropZone-title {
  color: #787878;
  font-weight: bold;
}

.dropZone input {
  position: absolute;
  cursor: pointer;
  top: 0px;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}

.dropZone-upload-limit-info {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}

.dropZone-over {
  background: #5C5C5C;
  opacity: 0.8;
}

.dropZone-uploaded {
  width: 100%;
  height: 200px;
  position: relative;
  border: 2px dashed #eee;
}

.dropZone-uploaded-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  /*color: #5C5C5C;*/
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
  text-align: center;
}

.removeFile {
  width: 200px;
}
</style>



// WEBPACK FOOTER //
// IndividualRecords.vue?1e440a33